<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="serverError === null">
  <div class="row">
    <div class="col">
      <a [routerLink]="getBackLink()" class="btn btn-link">&larr; Back</a>
    </div>
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <b *ngIf="!loadingBooking">CANCEL BOOKING</b>
        <b *ngIf="loadingBooking">LOADING BOOKING...</b>
      </p>
    </div>
    <div class="col"></div>
  </div>

  <div class="mb-3 border-rounded-10" *ngIf="!loadingBooking">
    <form (submit)="onSubmit()" class="m-4">
      <p>You are attempting to cancel and/or refund reservations on the following booking:</p>

      <div class="row mb-5">
        <div class="col-md-8 col-xl-6">
          <div class="row mb-2">
            <div class="col-6">
              <h5 class="mb-0">{{ booking.event_type_name }}</h5>
              <span>Event</span>
            </div>
          </div>
          <div class="row mb-2" *ngFor="let eventPart of booking.event_parts">
            <div class="col-6">
              <h5 class="mb-0">{{ eventPart.event_date_str }}</h5>
              <span>Date</span>
            </div>
            <div class="col-6">
              <h5 class="mb-0">
                {{ timeStringFromISO8601(eventPart.event_start_datetime) }} -
                {{ timeStringFromISO8601(eventPart.event_end_datetime) }}
              </h5>
              <span>Time</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group mb-5">
        <label>
          Reservations to Cancel:
        </label>
        <div class="form-check" *ngFor="let reservation of booking.active_reservations">
          <input class="form-check-input" type="checkbox" id="cancelRes{{ reservation.id }}"
                 name="cancelRes{{ reservation.id }}"
                 (click)="toggleCancelReservation(reservation.id)"
                 [checked]="reservationIdsToCancel.indexOf(reservation.id, 0) >= 0">
          <label class="form-check-label" for="cancelRes{{ reservation.id }}">
            {{ reservation.first_name }} {{ reservation.last_name }}
            <ng-container *ngIf="reservation.fee_name">
              ({{ capitalizeFirstLetter(reservation.fee_name) }})
            </ng-container>
            <ng-container *ngIf="reservation.add_on_names.length > 0">
              <br>
              Includes
              add-on{{ reservation.add_on_names.length > 1 ? 's' : '' }}:
              {{ (reservation.add_on_names_display || reservation.add_on_names).join(', ') }}
            </ng-container>
          </label>
        </div>
        <div class="form-check" *ngFor="let reservation of booking.cancelled_reservations">
          <input class="form-check-input disabled" type="checkbox" disabled
                 name="oldRes{{ reservation.id }}">
          <label class="form-check-label" for="cancelRes{{ reservation.id }}" style="text-decoration: line-through;">
            {{ reservation.first_name }} {{ reservation.last_name }}
            <ng-container *ngIf="reservation.fee_name">
              ({{ capitalizeFirstLetter(reservation.fee_name) }})
            </ng-container>
            <ng-container *ngIf="reservation.add_on_names.length > 0">
              Includes
              add-on{{ reservation.add_on_names.length > 1 ? 's' : '' }}:
              {{ (reservation.add_on_names_display || reservation.add_on_names).join(', ') }}
            </ng-container>
          </label>
        </div>
        <a href="#"
           *ngIf="(booking.active_reservations.length > 0) && (reservationIdsToCancel.length < booking.active_reservations.length)"
           (click)="selectAllReservationsToCancel();$event.preventDefault();">Select All</a>
        <a href="#"
           *ngIf="(booking.active_reservations.length > 0) && (reservationIdsToCancel.length >= booking.active_reservations.length)"
           (click)="reservationIdsToCancel = [];$event.preventDefault();">Deselect All</a>
      </div>

      <div *ngIf="(booking.total_currency_amount > 0) || (booking.total_num_vouchers > 0)">
        <p>
          There was a fee associated with this booking.
        </p>

        <div class="row mb-5">
          <div class="col-md-8 col-xl-6">
            <div class="row mb-2">
              <div class="col-6">
                <h5 class="mb-0">
                  {{ organizationConfigService.getCurrencySymbol() }}{{ booking.total_currency_amount|number:'.2' }}
                  <ng-container *ngIf="booking.total_num_vouchers > 0">+ {{ booking.total_num_vouchers }} voucher(s)</ng-container>
                </h5>
                <span>Payment Amount</span>
              </div>
              <div class="col-6">
                <h5 class="mb-0">{{ booking.payment_method_text }}</h5>
                <span>Payment Method</span>
              </div>
            </div>
            <div class="row">
              <div class="col-6" *ngIf="(booking.refunded_currency_amount > 0) || (booking.refunded_num_vouchers > 0)">
                <h5 class="mb-0">
                  {{ organizationConfigService.getCurrencySymbol() }}{{ booking.refunded_currency_amount|number:'.2' }}
                  <!-- ngIf uses total_num_vouchers, not refunded_num_vouchers, because we would like to explicitly show 0 -->
                  <ng-container *ngIf="booking.total_num_vouchers > 0">+ {{ booking.refunded_num_vouchers }} voucher(s)</ng-container>
                </h5>
                <span>Previously Refunded Amount</span>
              </div>
              <div class="col-6">
                <h5 class="mb-0">#{{ booking.payment_reference }}</h5>
                <span>Payment Reference</span>
              </div>
            </div>
            <div class="row">
              <div class="col-6" *ngIf="(booking.refunded_currency_amount > 0) || (booking.refunded_num_vouchers > 0)">
                <h5 class="mb-0">
                  {{ organizationConfigService.getCurrencySymbol() }}{{ booking.unrefunded_currency_amount|number:'.2' }}
                  <!-- ngIf uses total_num_vouchers, not unrefunded_num_vouchers, because we would like to explicitly show 0 -->
                  <ng-container *ngIf="booking.total_num_vouchers > 0">+ {{ booking.unrefunded_num_vouchers }} voucher(s)</ng-container>
                </h5>
                <span>Remaining Unrefunded Amount</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group mb-5">
          <fieldset>
            <span>Refund Options *</span>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="refundSelection" required
                     id="refundOptionNo"
                     [value]="refundOptions.noRefund"
                     [(ngModel)]="refundSelection">
              <label class="form-check-label" for="refundOptionNo">No Refund</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="refundSelection" required
                     id="refundOptionPartial"
                     [value]="refundOptions.partialRefund"
                     [(ngModel)]="refundSelection">
              <label class="form-check-label" for="refundOptionPartial">Partial Refund</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="refundSelection" required
                     id="refundOptionFull"
                     [value]="refundOptions.fullRefund"
                     [(ngModel)]="refundSelection">
              <label class="form-check-label" for="refundOptionFull">Full Booking Refund</label>
            </div>
          </fieldset>

          <div class="row mt-2" *ngIf="refundSelection === refundOptions.partialRefund">
            <div class="col-md-8 col-xl-6">
              <div class="row">
                <div class="col-6" *ngIf="booking.total_currency_amount > 0">
                  <label for="refundCurrencyAmount">Amount to Refund</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{ organizationConfigService.getCurrencySymbol() }}</span>
                    </div>
                    <input type="number" min="0" [max]="booking.total_currency_amount" step="0.01"
                           class="form-control" id="refundCurrencyAmount" name="refundCurrencyAmount"
                           [(ngModel)]="refundCurrencyAmount">
                  </div>
                </div>
                <div class="col-6" *ngIf="booking.total_num_vouchers > 0">
                  <label>Vouchers to Refund</label>
                  <input type="number" min="0" [max]="booking.total_num_vouchers" step="1"
                         class="form-control" id="refundVoucherCount" name="refundVoucherCount"
                         [(ngModel)]="refundVoucherCount">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="reservationIdsToCancel.length > 0" class="row mb-4">
        <div class="col-md-8 col-xl-6">

          <div class="form-group">
            <label for="sendCancellationEmails">
              Send Cancellation Notification Emails
            </label>
            <select class="custom-select"
                    id="sendCancellationEmails"
                    name="sendCancellationEmails"
                    [(ngModel)]="sendCancellationEmails">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>

          <ng-container *ngIf="sendCancellationEmails">

            <p class="mb-2">You may optionally include a message below to send to each cancelled registrant explaining why the reservation was cancelled.</p>

            <div class="form-group">
              <label>Cancellation Email Text</label>
              <app-markdown-editor [id]="'cancellationEmailInput'"
                                   [(content)]="cancellationEmailText"></app-markdown-editor>
            </div>

          </ng-container>

        </div>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-warning" role="alert"
           *ngIf="(refundSelection === refundOptions.fullRefund) && (reservationIdsToCancel.length < booking.active_reservations.length)">
        Warning: You have chosen to fully refund the booking, but you have not chosen to cancel all of its reservations.
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <button type="submit" class="btn btn-danger mr-2"
                [disabled]="isLoading()" [class.disabled]="isLoading()">
          Submit
        </button>
      </div>
      <a class="btn btn-secondary" [routerLink]="getBackLink()">
        Back
      </a>
    </form>
  </div>

</div>
